let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5dO6T")).then(() => parcelRequire('a6mRS'));